var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEngagementSummaryMentorshipOverviewSessionPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 124.77 211.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.45;}.cls-2{fill:url(#radial-gradient);}.cls-3{fill:#b499c7;}.cls-4{fill:#3ac2d7;}.cls-5{fill:none;stroke-miterlimit:10;stroke:url(#linear-gradient);}.cls-6{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -806.98,
    cy: 4088.88,
    r: 98.19,
    gradientTransform: "matrix(-1, 0, 0, 1, -754.52, -3890.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c0ddf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a9acf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -874.13,
    y1: 3995.95,
    x2: -812.49,
    y2: 3995.95,
    gradientTransform: "matrix(-1, 0, 0, 1, -754.52, -3890.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#3ac2d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b498c6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -873.63,
    y1: 3911.92,
    x2: -873.63,
    y2: 3950.45,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MENTOR_PROFILE",
    "data-name": "MENTOR PROFILE"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.51,186.26l6.9-2.69a4.8,4.8,0,0,1,5.24,1.14c.34.38.69.74,1.05,1.1a4.76,4.76,0,0,1,.95,5.29l-3,6.8a4.83,4.83,0,0,0,2.49,6.36l14.89,6.53a4.84,4.84,0,0,0,6.37-2.49l3-6.79a4.78,4.78,0,0,1,4.54-2.89c.5,0,1,0,1.52,0a4.79,4.79,0,0,1,4.39,3.07l2.7,6.91a4.83,4.83,0,0,0,6.25,2.74l15.15-5.92a4.82,4.82,0,0,0,2.74-6.25L85,192.29a4.78,4.78,0,0,1,1.14-5.24c.38-.34.74-.69,1.1-1.05a4.77,4.77,0,0,1,5.29-.95l6.8,3a4.83,4.83,0,0,0,6.36-2.49l6.52-14.89a4.83,4.83,0,0,0-2.48-6.37l-6.8-3a4.78,4.78,0,0,1-2.88-4.54c0-.5,0-1,0-1.52a4.79,4.79,0,0,1,3.07-4.39l6.91-2.7a4.83,4.83,0,0,0,2.74-6.25l-5.92-15.15a4.82,4.82,0,0,0-6.25-2.74l-6.91,2.69a4.78,4.78,0,0,1-5.24-1.14c-.34-.37-.69-.74-1-1.1a4.76,4.76,0,0,1-1-5.29l3-6.79A4.84,4.84,0,0,0,87,106L72.07,99.5A4.84,4.84,0,0,0,65.7,102l-3,6.8a4.81,4.81,0,0,1-4.54,2.89c-.5,0-1,0-1.52,0a4.77,4.77,0,0,1-4.39-3.07l-2.7-6.91a4.83,4.83,0,0,0-6.25-2.74l-15.15,5.92a4.83,4.83,0,0,0-2.74,6.26l2.69,6.9A4.78,4.78,0,0,1,27,123.23c-.37.34-.74.7-1.1,1a4.76,4.76,0,0,1-5.29,1l-6.79-3a4.84,4.84,0,0,0-6.37,2.49L.92,139.63A4.84,4.84,0,0,0,3.4,146l6.8,3a4.81,4.81,0,0,1,2.89,4.54c0,.5,0,1,0,1.52A4.79,4.79,0,0,1,10,159.42l-6.91,2.7a4.84,4.84,0,0,0-2.74,6.26l5.92,15.14A4.83,4.83,0,0,0,12.51,186.26Zm22.38-20.55a24.11,24.11,0,1,1,28.59,12.53A24.12,24.12,0,0,1,34.89,165.71Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 56.49,
    cy: 156.13,
    r: 5.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.1,
    cy: 156.13,
    r: 5.67
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "119.1 54.17 119.1 156.13 57.96 156.13"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 118.58,
    y: 6.06,
    width: 1.04,
    height: 63.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 118.55,
    cy: 5.67,
    r: 5.67
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngagementSummaryMentorshipOverviewSessionPlan);
export default __webpack_public_path__ + "static/media/engagementSummaryMentorshipOverviewSessionPlan.d42cd831fb2dbddcd538eeb372b64873.svg";
export { ForwardRef as ReactComponent };